import { Avatar, List, Tag, Input, Button, Image, message } from 'antd';
import { _fetch } from '../../_fetch';
import moment from 'moment';
import { Comment } from '@ant-design/compatible';
import { Select } from 'antd';
import { user_role } from "../../consts";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import UploadSnapshot from '../../components/uploadSnapshot';
import UserInfo from '../userInfo';
import { useGetAllUsers } from '../../utils/queryUtils';
import { useParams, useSearchParams } from 'react-router-dom';
import { trackEvent } from '../../utils/mixpanel';

export default function CommentView({ queryId, query_id = null, comments = null, setComments = null, sendEmail, fy = null, onCommentAdded = null, show = true, setShow = () => { }, selectedPrimaryClient = false }) {
    const files = [
        {
            commentId: "1",
            path: "https://example.com/image1.png",
            name: "image1---uniqueId1",
            createdAt: "2023-10-01T12:00:00Z"
        },
        {
            commentId: "1",
            path: "https://example.com/image2.png",
            name: "image2---uniqueId2",
            createdAt: "2023-10-02T12:00:00Z"
        },
        {
            commentId: "2",
            path: "https://example.com/image3.png",
            name: "image3---uniqueId3",
            createdAt: "2023-10-03T12:00:00Z"
        }
    ];
    const { Option } = Select;
    const [newComment, setNewComment] = useState('');
    const [toggle, setTogle] = useState(false)
    const [filesWaiting, setFilesWaiting] = useState(false);
    const { companyName } = useParams();
    const userData = useGetAllUsers(false, {}, companyName)?.data;
    const all_users = userData?.data;
    const { company: selected } = useSelector((st) => st.selected);
    const [searchParams,] = useSearchParams();
    const activaTab = useState(searchParams.get("tab") || "queries");
    const [, setSeed] = useState(1);
    const { role } = useSelector(st => st.user);
    const [user, setUser] = useState([]);
    const reset = () => {
        setSeed(Math.random());
    };

    const handleChange = (value) => {
        setUser([...value])
    };

    useEffect(() => {
        if (newComment?.length === 0) {
            setUser([])
            setTogle(false)
        }

    }, [newComment])

    async function handleNewComment() {
        var payload = {}
        if (query_id || queryId) {
            payload = {
                query: queryId,
                query_id: query_id,
                text: newComment,
                isPrimaryClientComments: activaTab[0] === "primary_client_queries" ? true : false,
            }
        }
        else if (fy) {
            payload = {
                fy: fy,
                text: newComment,
                arr: user
            }
            if (selectedPrimaryClient?._id) {
                payload.arr = [selectedPrimaryClient?._id];
                payload.isPrimaryClientComments = true
            }
        }
        try {
            let res = await _fetch(`${process.env.REACT_APP_API_URL}/comment`, {
                method: 'POST',
                body: {
                    ...payload
                },
            });
            if (res.status === 201) {
                let result = await res.json();
                message.success("Comment added successfully");
                setNewComment('');
                setComments((c) => [result, ...c]);
                setUser([])
                setTogle(false)
                onCommentAdded && onCommentAdded({ status: "OPEN" });
                setShow(false)
                trackEvent("Add Comment", {
                    query_id: query_id,
                    comment_id: result._id,
                    query: queryId,
                    text: newComment,
                    isPrimaryClientComments: activaTab[0] === "primary_client_queries" ? true : false,
                    arr: user,
                    fy: fy
                });

                return result._id;
            }
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <React.Fragment>

            <div>


                <div>
                    <Input.TextArea
                        id='comment'
                        placeholder='type your comment...'
                        autoSize={{
                            minRows: 5,
                            maxRows: 10,
                        }}
                        value={newComment}
                        onChange={(e) =>
                            setNewComment(
                                e.target.value
                            )
                        }
                    />
                    <UploadSnapshot
                        setFilesWaiting={
                            setFilesWaiting
                        }
                        refresh={reset}
                        id={query_id}
                    />
                </div>

                {(newComment || filesWaiting) && (
                    <div className='d-flex align-items-center justify-content-start my-2'>
                        <Button
                            type='default'
                            className='me-2'
                            onClick={() => {
                                setNewComment("");
                                setUser([]);
                                setTogle(false);
                            }}
                            size='large'
                        >
                            Cancel
                        </Button>

                        {toggle && role !== user_role.PRIMARY_CLIENT && !selectedPrimaryClient?.id && <Select
                            mode="multiple"
                            showSearch
                            style={{ minWidth: "400px" }}
                            className="me-2"
                            size="large"
                            placeholder="Select User"
                            defaultValue={user}
                            onChange={handleChange}
                            optionLabelProp="label"
                            optionFilterProp="label"
                            filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes((input || "").toLowerCase())}

                        >
                            {
                                all_users?.filter(
                                    (e) =>
                                        e.role === user_role.ADMIN ||
                                        e.company_ids?.some((f) => f._id === selected._id)
                                ).map((elem) => <Option label={elem.first_name + ' ' + elem.last_name} value={elem._id} key={elem._id}>

                                    <UserInfo firstName={elem.first_name} lastName={elem.last_name} email={elem.email} />

                                </Option>)}



                        </Select>}




                        {<Button
                            type="primary"
                            disabled={!selectedPrimaryClient?.minWidth && toggle && !user?.length}
                            onClick={async () => {
                                if (selectedPrimaryClient?._id) {
                                    console.log("selectedPrimaryClient", selectedPrimaryClient);
                                    // Always just submit
                                    let commentId = await handleNewComment();
                                    window.myFileUpload(commentId);
                                    return;
                                }

                                if (!toggle && role === user_role.PRIMARY_CLIENT && sendEmail) {
                                    console.log("inside !toggle and primaryClient");
                                    let commentId = await handleNewComment();
                                    window.myFileUpload(commentId);
                                } else if (!toggle && sendEmail) {
                                    console.log("inside toggle");
                                    setTogle(true); // only for non-selectedPrimaryClient case
                                } else {
                                    console.log("Inside else")
                                    let commentId = await handleNewComment();
                                    window.myFileUpload(commentId);
                                }
                            }}
                        >
                            {sendEmail ? "Send Email" : "Submit"}
                        </Button>
                        }


                    </div>
                )}

            </div>
            {comments ?
                <List
                    className='comment-list w-100 px-3'
                    itemLayout='horizontal'
                    dataSource={comments}
                    pagination={{
                        pageSize: 10,
                    }}
                    renderItem={(item) => (
                        <Comment
                            style={{ margin: "9px 0px", backgroundColor: "#FAFAFA", paddingLeft: "10px" }}
                            author={
                                <div>
                                    <span>
                                        <b>{item?.created_by?.first_name} {item?.created_by?.last_name}</b>
                                        <span className='ms-2'>
                                            {moment(item?.createdAt).format("DD MMM YYYY HH:mm")}
                                        </span>
                                    </span>
                                </div>
                            }
                            avatar={
                                <Avatar shape='square'>
                                    {item?.created_by?.first_name}
                                    {item?.created_by?.last_name}
                                </Avatar>
                            }
                            content={(<div style={{ backgroundColor: "#FAFAFA" }}>
                                <span style={{ whiteSpace: "pre-line", fontSize: "12px", fontWeight: "400" }}> {item?.text} {" "}</span>
                                {role !== user_role.PRIMARY_CLIENT &&
                                    item?.created_for?.length !== 0 &&
                                    <p>
                                        <span style={{ color: "#6FBAFF", fontWeight: "600", fontSize: "12px" }}>Recipients</span>
                                    </p>
                                }
                                {role !== user_role.PRIMARY_CLIENT && (<span style={{ color: "#00000073", fontWeight: "700", fontSize: "12px" }}>
                                    {item?.created_for?.map((el, i) => el?.first_name + " " + el?.last_name).join(", ")}
                                </span>)}
                                <div>

                                    {files?.filter((s) => s.commentId === item._id)
                                        ?.length
                                        ? files
                                            ?.filter(
                                                (s) => s.commentId === item._id
                                            )
                                            .map((e) => (
                                                <Tag
                                                    className='pointer m-1'
                                                    style={{
                                                        padding: '9px',
                                                        borderRadius: '5px',
                                                        maxWidth: '180px',
                                                    }}
                                                    key={e._id}
                                                >
                                                    <Image src={e.path} />
                                                    <div>
                                                        {(() => {
                                                            // making our custom unique identifier vanish ex-(seperated by --- ,filename.png---gedy2u1et6 ) to filename.png
                                                            e.name = e.name.split('---')[0];
                                                            const changedName =
                                                                e?.name?.length <= 15
                                                                    ? `${e.name}`
                                                                    : `${e.name
                                                                        .split('.')[0]
                                                                        .slice(0, 12)}...${e.name.split('.')[1]
                                                                    }`;

                                                            return changedName;
                                                        })()}
                                                    </div>
                                                    <div>{moment.utc(e.createdAt).format("DD MMM YYYY HH:mm")}</div>
                                                </Tag>
                                            ))
                                        : null}
                                </div>
                            </div>)}
                        />
                    )}
                /> : null}
        </React.Fragment>
    );
}
